
const TossPopup= () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
    <h1 className="text-3xl font-bold mb-6 text-center">개인정보 제3자 제공 동의</h1>

    <section id="purpose" className="mb-8">
      <p>
        IOPS SPACE 서비스 내 이용자 식별, 통계, 계정연동 및 결제서비스 등을 위해 이용자 식별정보와 함께 개인정보가 제공됩니다. 제공된 정보는 서비스 이용기간 동안 활용/보관됩니다. 본제공 동의를 거부할 권리가 있으나, 동의를 거부하실 경우 서비스 이용이 제한될 수 있습니다.
      </p>
    </section>

    <section className="mb-8">
      <span><b>1. 제공받는 자:</b></span>
      <ol className="pl-5 space-y-2">
        <p>토스페이먼츠</p>
      </ol>
    </section>

    <section className="mb-8">
      <span><b>2. 제공 목적:</b></span>
      <ol className="pl-5 space-y-2">
        <p>간편결제 서비스 업무 대행</p>
      </ol>
    </section>

    <section className="mb-8">
      <span><b>3. 제공항목:</b></span>
      <ol className="pl-5 space-y-2">
        <p>서비스 결제, 환불절차를 위해 필요한 정보 (OrderId(주문번호), amount(금액), paymentKey(키값))등</p>
      </ol>
    </section>

    <section className="mb-8">
      <span><b>4. 보유 및 이용기간:</b></span>
      <ol className="pl-5 space-y-2">
        <p>서비스 제공 완료 후 5년</p>
      </ol>
    </section>

  </div>
  );
};

export default TossPopup;

